import router from './router';
import store from '@/store/index.js';
import {getToken} from '@/utils/auth.js';
import {asyncAjax} from "@/utils";
import {getLoginUserInfo} from "@/api/login";

const whiteList = ['/login'];
router.beforeEach(async (to, from, next) => {

    if (whiteList.indexOf(to.path) === -1) {
        if (store.state.user.token) {
            next();
        } else {
            let token = getToken()
            if (token) {
                await store.commit('user/SET_TOKEN', token);
                await createRouters()
                next({ ...to, replace: true })
            } else {
                next('/login');
            }
        }
    } else {
        if (store.state.user.token) {
            next('/');
        } else {
            let token = getToken()
            if (token) {
                store.commit('user/SET_TOKEN', token);
                next('/');
            } else {
                next();
            }
        }
    }
})

// 初始化菜单
export async function createRouters() {
    if (store.state.user.token && !store.state.asyncRouter) {
        const [res] = await asyncAjax(getLoginUserInfo, {});
        store.state.user.userInfo = {...res.data.user, menus: res.data.menus}
        await store.dispatch('user/createRouters', res.data.menus).then(res => {
            router.addRoutes([...res, { path: '*', redirect: res[0].path, hidden: true }]);
        })
    }
}